module.exports = __webpack_public_path__ + "img/bg.e585d809.jpg";